import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import { Link } from 'react-router-dom'
import crumbContext from "contexts/crumbs"
import "./vae.scss"
export default function Vae() {
	const {setHeadband} = useContext(headbandContext)
	const {crumbs, setCrumbs} = useContext(crumbContext)
	useEffect(() => {
		setHeadband({
			title :  "La validation des acquis de l'expérience",
			icon : "picto_validation_acquis_experience.svg",
			color : "bckRed"
		})
	}, [])
	return (
		<div id="vae" className='page'>
			<img src="/vae.png" alt="" />
			<Link to={"/accueil/drhf/fiche_contact"}
				className='cadreClique'
				onClick={() => {
                    setCrumbs([
						{
							page :'/accueil',
							title : "Accueil"
						},
						{
							page : "/accueil/drhf",
							title : "Ma DRHF"
						},
						{
							page : "/accueil/drhf/fiche_contact",
							title : "Fiche contact"
						},
					])                       
                }} 
			></Link>
		</div>
	)
}
